import axios from 'axios'
import axiosRetry from 'axios-retry'
import { download } from '@/libs/api/downloader'

import { addAuthorizationHeader } from '@/libs/api/interceptors/request/addAuthorizationHeader.js'
import { waitForTokenRefresh } from '@/libs/api/interceptors/request/waitForTokenRefresh.js'
import { setApiBaseUrl } from '@/libs/api/interceptors/request/setApiBaseUrl.js'
import { notifyDeprecatedEndpoint } from '@/libs/api/interceptors/response/notifyDeprecatedEndpoint.js'
import { retryOnUnauthorized } from '@/libs/api/interceptors/response/retryOnUnauthorized.js'

/**
 * @type {AxiosInstance}
 */
const instance = axios.create({
  retryable: true, // Repeat query execution if the error was failed with code 401
  skipAuthWait: false, // Exclude refresh request for prevent deadlock
  skipAuth: false, // Send refresh token without Authorization header
})

// Request interceptors are registered from the last step to the first one.
// Axios executes them in reverse order: wait -> baseURL -> auth header.
instance.interceptors.request.use(addAuthorizationHeader)
instance.interceptors.request.use(setApiBaseUrl)
instance.interceptors.request.use(waitForTokenRefresh)

// Response interceptors run in registration order.
instance.interceptors.response.use(notifyDeprecatedEndpoint)
instance.interceptors.response.use((response) => response, retryOnUnauthorized)

// Keep the original promise pending while retrying rate-limited GET requests.
// Register after the 401 handler to also handle rate limits after token refresh.
// The default retry delay respects Retry-After without additional backoff.
axiosRetry(instance, {
  retries: Infinity,
  retryCondition: (error) =>
    error.response?.status === 429 && error.config?.method === 'get',
})

export { instance, download }
